export enum SpriteIconsType {
  Fire = "fire",
  Star = "star",
  HeartExplodeLong = "heart-explode-long",
  HeartExplodeShort = "heart-explode-short",
}
